"use strict";

try {
  console.debug('Pro Gallery Version: 1.8.2');
} catch (e) {}